import React from "react";
import { Controller, useFormContext, useWatch } from "react-hook-form";
import { intl } from "LocaleWrapper";
import { FormGroup, Table } from "@cofano/cck";
import RelationSelect from "../selects/RelationSelect";
import { Language } from "imports/Utils";
import { RelationSchemaInput, RelationSchemaOutput } from "view/relations/utils/relation.schema";
import { RelationType } from "__generated__/enums";

const RelationLinkedCustomersForm = () => {

	const { control } = useFormContext<RelationSchemaInput, unknown, RelationSchemaOutput>();

	const linkedRelations = useWatch({ control, name: "linkedRelations" });

	return (
		<React.Fragment>
			<FormGroup label={Language("LINKED_CUSTOMERS")} labelPlacement="left-center" overflow="hidden">
				<Controller
					name="linkedRelations"
					control={control}
					render={({ field }) => (
						<RelationSelect
							{...field}
							types={[ RelationType.Customer ]}
							multiple />
					)} />
			</FormGroup>

			<Table
				id="relationLinkedCustomersTable"
				content={linkedRelations ?? []}
				columns={[ {
					id: "name",
					title: intl.formatMessage({ id: "SHIPS_NAME" }),
				}, {
					id: "abbreviation",
					title: intl.formatMessage({ id: "CLIENT_ABBREVIATION" }),
				}, {
					id: "email",
					title: intl.formatMessage({ id: "EMAIL" }),
				} ]}
				disableFooter />
		</React.Fragment>
	);
};

export default RelationLinkedCustomersForm;
